var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCelo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 28C21.732 28 28 21.732 28 14C28 6.26801 21.732 0 14 0C6.26801 0 0 6.26801 0 14C0 21.732 6.26801 28 14 28Z",
    fill: "#282C31"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4737 16.5789C17.712 16.5789 19.5264 14.7645 19.5264 12.5263C19.5264 10.2881 17.712 8.47368 15.4737 8.47368C13.2355 8.47368 11.4211 10.2881 11.4211 12.5263C11.4211 14.7645 13.2355 16.5789 15.4737 16.5789ZM15.4737 18.0526C12.4217 18.0526 9.94742 15.5783 9.94742 12.5263C9.94742 9.47432 12.4217 7 15.4737 7C18.5257 7 21 9.47432 21 12.5263C21 15.5783 18.5257 18.0526 15.4737 18.0526Z",
    fill: "#35D07F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5263 19.5263C14.7645 19.5263 16.5789 17.7119 16.5789 15.4737C16.5789 13.2355 14.7645 11.4211 12.5263 11.4211C10.2881 11.4211 8.47368 13.2355 8.47368 15.4737C8.47368 17.7119 10.2881 19.5263 12.5263 19.5263ZM12.5263 21C9.47432 21 7 18.5257 7 15.4737C7 12.4217 9.47432 9.94737 12.5263 9.94737C15.5783 9.94737 18.0526 12.4217 18.0526 15.4737C18.0526 18.5257 15.5783 21 12.5263 21Z",
    fill: "#FBCC5C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.655 18.0497C16.038 17.5856 16.3125 17.0418 16.4584 16.4581C17.0421 16.3122 17.5859 16.0377 18.05 15.6548C18.0288 16.3307 17.8833 16.9969 17.6206 17.62C16.9974 17.8828 16.3311 18.0285 15.6551 18.0497H15.655ZM11.5418 11.5416C10.9581 11.6875 10.4143 11.962 9.9502 12.3449C9.97136 11.669 10.1169 11.0028 10.3796 10.3797C11.0028 10.117 11.6691 9.97144 12.3451 9.95032C11.9622 10.4143 11.6877 10.958 11.5418 11.5416Z",
    fill: "#ECFF8F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCelo);
export default __webpack_public_path__ + "static/media/celo.f7363d9eaa9ed6daaea0f8f48e793320.svg";
export { ForwardRef as ReactComponent };